// src/app/DisclosureSection.jsx
//
// Shared controlled disclosure toggle used by AccordionFieldPanel,
// ActivitySection, and MethodologyAccordion (Score tab).
//
// Canonical pattern: section title on the left, "▼ Show" / "▲ Hide"
// on the right. State management lives in the caller.

import React from "react";
import { T } from "./tokens.js";

export function DisclosureSection({
  title,
  open,
  onToggle,
  children,
  buttonTestId,
  buttonPadding = "14px 20px",
}) {
  return (
    <>
      <button
        type="button"
        data-testid={buttonTestId}
        onClick={onToggle}
        aria-expanded={open}
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: buttonPadding,
          background: "none",
          border: "none",
          cursor: "pointer",
          fontSize: T.fsBase,
          fontWeight: T.fwSemibold,
          color: T.dark,
          textAlign: "left",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 8, flex: 1 }}>
          {title}
        </span>
        <span style={{ fontSize: T.fsXs, color: T.mid, fontWeight: T.fwRegular, flexShrink: 0 }}>
          {open ? "▲ Hide" : "▼ Show"}
        </span>
      </button>
      {open && children}
    </>
  );
}
